//import SplitType from 'split-type';
import LocomotiveScroll from 'locomotive-scroll';
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import common from './common';

gsap.registerPlugin(ScrollTrigger);

const scroll = {

    debounce(func, wait = 100) {
        let timeout;
        return function (...args) {
            const context = this;
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(context, args), wait);
        };
    },
    backgroundMemory: {
        lastY: null,             // scrollY lors du changement
        lastDirection: null,     // 'down' ou 'up'
        lastBg: null,            // classe appliquée
        prevBg: null             // classe précédente
    },
    scrollTriggerDirection: null,
    locomotiveScroll: null,
    observRatio: 0.3,
    lastScrollY: window.scrollY,
    currentBgClass: null,
    observers: {
        section: null,
        general: null,
        revealTxt: null,
    },
    count: 0,
    background: {
        pending: {
            newBgClass: null,
            startScrollY: window.scrollY,
            direction: null,
            validated: false
        },
        currentBgClass: null,
        lastScrollY: window.scrollY,
        observer: null
    },
    revealElementsInView: [],

    show() {
        this.locomotive();
        //this.observe();
        this.initBackground();
        this.initReveal();
        //this.initChangeBgObserver();
        //this.initSectionObserver();
    },
    initReveal() {
        const reveals = document.querySelectorAll('.reveal');

        reveals.forEach((el) => {
            ScrollTrigger.create({
                trigger: el,
                start: "top 90%",
                once: true,
                onEnter: () => {
                    // Trouve le conteneur parent qui contient tous les reveals groupés
                    const container = el.closest('.row, .container, ._section, ._section_refresh') || document.body;

                    const groupReveals = Array.from(container.querySelectorAll('.reveal')).filter(elem => {
                        const r = elem.getBoundingClientRect();
                        return r.top < window.innerHeight; // filtre rapide pour ceux en vue
                    });

                    const groupIndex = groupReveals.indexOf(el);
                    const delay = groupIndex >= 0 ? groupIndex * 100 : 0;

                    el.setAttribute('data-delay', delay);

                    setTimeout(() => {
                        el.classList.add('reveal-visible');
                    }, delay);
                }
            });
        });
    },
    initBackground() {
        const _this = this;
        const triggers = document.querySelectorAll(".__change_bg");

        triggers.forEach(triggerEl => {
            // Cas normal → scroll vers le bas
            ScrollTrigger.create({
                trigger: triggerEl,
                start: "top 40%",
                onEnter: () => {
                    _this.changeBackground(triggerEl.dataset.down);
                },
                markers: false
            });

            // Cas normal → scroll vers le haut
            ScrollTrigger.create({
                trigger: triggerEl,
                start: "top bottom",
                end: "top 50%",
                onEnterBack: () => {
                    _this.changeBackground(triggerEl.dataset.up);
                },
                markers: false
            });
        });

        // 🔁 Système de secours : observer la zone visible au centre du viewport
        ScrollTrigger.create({
            start: 0,
            end: "max",
            onUpdate: (self) => {
                const direction = self.direction === 1 ? "down" : "up";
                const checkLine = direction === "down"
                    ? window.innerHeight * 0.55
                    : window.innerHeight * 0.45;

                const currentY = window.scrollY;
                scroll.scrollTriggerDirection = direction; // pour mémoire globale

                let selected = null;

                document.querySelectorAll(".__change_bg").forEach(triggerEl => {
                    const rect = triggerEl.getBoundingClientRect();

                    if (
                        direction === "down" && rect.top <= checkLine && rect.bottom > checkLine ||
                        direction === "up" && rect.top <= checkLine && rect.bottom > checkLine
                    ) {
                        selected = triggerEl;
                    }
                });

                // ✅ Cas 1 : changement classique par proximité d'une section
                if (selected) {
                    const newClass = selected.dataset[direction];
                    if (newClass && newClass !== scroll.currentBgClass) {
                        _this.changeBackground(newClass);
                    }
                }

                // ✅ Cas 2 : retour arrière — déclenche le background précédent
                const memory = scroll.backgroundMemory;
                if (memory.lastY !== null && memory.lastDirection && memory.prevBg) {
                    const delta = currentY - memory.lastY;

                    const shouldRevert =
                        (memory.lastDirection === 'down' && direction === 'up' && delta <= -150) ||
                        (memory.lastDirection === 'up' && direction === 'down' && delta >= 250);

                    if (shouldRevert && scroll.currentBgClass !== memory.prevBg) {
                        _this.changeBackground(memory.prevBg);

                        // Reset mémoire pour ne pas relancer
                        scroll.backgroundMemory.lastY = null;
                        scroll.backgroundMemory.lastDirection = null;
                    }
                }
            }
        });

    },

    // initBackground() {
    //     let _this = this;
    //     document.querySelectorAll(".__change_bg").forEach(triggerEl => {
    //         ScrollTrigger.create({
    //             trigger: triggerEl,
    //             start: "top bottom",
    //             end: "bottom top",
    //             onEnter: () => {
    //                 _this.changeBackground(triggerEl.dataset.down);
    //             },
    //             onEnterBack: () => {
    //                 _this.changeBackground(triggerEl.dataset.up);
    //             },
    //             onUpdate: (self) => {
    //                 const progress = self.progress;
    //
    //                 if (self.isActive && Math.abs(progress - 0.5) < 0.05) {
    //                     const bg = self.direction === 1
    //                         ? triggerEl.dataset.down
    //                         : triggerEl.dataset.up;
    //                     _this.changeBackground(bg);
    //                 }
    //             },
    //             markers: false
    //         });
    //     });
    // },
    changeBackground(newClass) {
        if (!newClass || newClass === scroll.currentBgClass) return;

        // Save background memory
        scroll.backgroundMemory.prevBg = scroll.backgroundMemory.lastBg;
        scroll.backgroundMemory.lastBg = newClass;
        scroll.backgroundMemory.lastY = window.scrollY;
        scroll.backgroundMemory.lastDirection = scroll.scrollTriggerDirection || 'down'; // fourni plus bas

        // animation
        const bgContainer = document.querySelector("._backgrounds");
        const bands = bgContainer.querySelectorAll(".bg-band");

        if (scroll.currentBgClass) {
            document.body.classList.remove(scroll.currentBgClass);
        }
        document.body.classList.add(newClass);
        scroll.currentBgClass = newClass;

        //alert(newClass);

        bgContainer.className = "_backgrounds " + newClass;

        // Animation bandes vers le bas
        gsap.set(bands, { y: "-100%" });
        gsap.to(bands, {
            y: "0%",
            duration: 0.6,
            stagger: 0.1,
            ease: "power2.out",
            onComplete: () => {
                // Appliquer la nouvelle classe sur le body

                gsap.set(bands, { y: "-100%" });
                // // Animation retour des bandes vers le haut
                // gsap.to(bands, {
                //     y: "-100%",
                //     delay: 0,
                //     duration: 0,
                //     stagger: 0.1,
                //     ease: "power2.in"
                // });
            }
        });


        // if (scroll.currentBgClass) {
        //     document.body.classList.remove(scroll.currentBgClass);
        // }
        // document.body.classList.add(newClass);
        // scroll.currentBgClass = newClass;

    },
    observe() {

        this.observers.section = new IntersectionObserver(this.handleSections.bind(this), {
            root: null,
            rootMargin: '0px 0px -30% 0px',
            threshold: [0.05, 0.1, 0.2, 0.3, 0.5, 0.7, 0.9] // Détection fine
        });
        this.observers.general = new IntersectionObserver(this.handleIntersect.bind(this), {
            root: null,
            rootMargin: '0px',
            //threshold: this.observRatio
            threshold: [0.6, 0.9]
        });


        // this.observers.revealTxt = new IntersectionObserver(this.handleRevealTxt.bind(this), {
        //     root: null,
        //     rootMargin: '0px',
        //     threshold: [0.1, 0.3, 0.6, 0.9]
        // });
        //
        // this.observers.global = new IntersectionObserver(this.handleGlobalOpacity.bind((this)), {
        //     root: null, // Utilise le viewport comme référence
        //     rootMargin: '0px',
        //     threshold: [0, 0.1, 0.2, 0.5, 0.7, 1] // Seuils pour les déclencheurs de la fonction
        // });

        document.querySelectorAll('.reveal,.reveal_img,.reveal_op,._reveal_title,.line').forEach(el => this.observers.general.observe(el));
        document.querySelectorAll('._section,._section_refresh').forEach(el => this.observers.section.observe(el));
        //document.querySelectorAll('.reveal-txt').forEach(el => this.observers.revealTxt.observe(el));
        //document.querySelectorAll('.reveal-opacity').forEach(el => this.observers.global.observe(el));


    },

    // initSectionObserver() {
    //     let _this = this;
    //
    //     const sections = document.querySelectorAll('.__change_bg');
    //
    //     scroll.background.observer = new IntersectionObserver(_this.handleSectionIntersect, {
    //         root: null,
    //         threshold: 0.01 // juste besoin de savoir quand le div entre
    //     });
    //     sections.forEach(section => scroll.background.observer.observe(section));
    // },
    // handleSectionIntersect(entries) {
    //     const scrollY = window.scrollY;
    //     const direction = scrollY > scroll.background.lastScrollY ? "down" : "up";
    //     scroll.background.lastScrollY = scrollY;
    //
    //     entries.forEach(entry => {
    //         if (!entry.isIntersecting) return;
    //
    //         const el = entry.target;
    //         const rect = el.getBoundingClientRect();
    //         const thresholdTop = window.innerHeight * 0.1; // 10% du haut
    //         const thresholdBottom = window.innerHeight * 0.9; // 90% du bas
    //
    //         let newBgClass = null;
    //
    //         // Si la balise entre par le haut (scroll up)
    //         if (rect.bottom < thresholdTop) {
    //             newBgClass = el.dataset.up;
    //         }
    //
    //         // Si la balise entre par le bas (scroll down)
    //         else if (rect.top > thresholdBottom) {
    //             newBgClass = el.dataset.down;
    //         }
    //
    //         if (!newBgClass || newBgClass === scroll.background.currentBgClass) return;
    //
    //         // Appliquer la nouvelle couleur
    //         if (scroll.background.currentBgClass) {
    //             document.body.classList.remove(scroll.background.currentBgClass);
    //         }
    //
    //         document.body.classList.add(newBgClass);
    //         scroll.background.currentBgClass = newBgClass;
    //
    //         console.log(`[${direction}] BG changé → ${newBgClass}`);
    //     });
    // },
    handleSections(entries) {
        entries.forEach(entry => {
            const currentScrollY = window.scrollY;
            const scrollDirection = currentScrollY > scroll.lastScrollY ? 'down' : 'up';
            scroll.lastScrollY = currentScrollY;

            if (entry.isIntersecting) {
                // 🔁 On remet le compteur général à 0 (si nécessaire ailleurs)
                this.count = 0;

                // 🧼 On remet à zéro les reveals de la section active
                const reveals = entry.target.querySelectorAll('.reveal, .reveal_img, .reveal_op, ._reveal_title, .line');

                let localCount = 1; // compteur local à la section

                reveals.forEach(el => {
                    // Nettoyage des classes précédentes
                    el.classList.remove(
                        'reveal-visible',
                        'reveal-img-visible',
                        'reveal_op-visible',
                        'reveal_title_visible',
                        'reveal_line'
                    );

                    // Suppression des classes delay
                    [...el.classList].forEach(cls => {
                        if (cls.startsWith('reveal-delay-')) {
                            el.classList.remove(cls);
                        }
                    });

                    // 👇 Re-observe pour relancer `handleIntersect`
                    this.observers.general.unobserve(el);
                    this.observers.general.observe(el);

                    // ❗️ Ajoute la bonne nouvelle classe delay immédiatement
                    el.classList.add(`reveal-delay-${localCount}`);
                    localCount++;
                });
            }
        });
    },

    handleIntersect(entries) {
        entries.forEach(entry => {
            if (entry.intersectionRatio > this.observRatio) {
                //this.count++;
                if (entry.target.classList.contains('reveal')) {
                    entry.target.classList.remove('reveal_less');
                    entry.target.classList.add('reveal-visible');
                } else if (entry.target.classList.contains('line')) {
                    entry.target.classList.add('reveal_line');
                } else if (entry.target.classList.contains('reveal_op')) {
                    entry.target.classList.add('reveal_op-visible');
                } else if (entry.target.classList.contains('_reveal_title')) {
                    entry.target.classList.add('reveal_title_visible');
                } else {
                    entry.target.classList.add('reveal-img-visible');
                }
                //entry.target.classList.add(`reveal-delay-${entry.target.dataset.delay || this.count}`);
            }
        });
    },


    handleRevealTxt(entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Ajouter l'élément au tableau si visible
                if (!this.revealElementsInView.includes(entry.target)) {
                    this.revealElementsInView.push(entry.target);
                }
            } else {
                // Retirer l'élément du tableau s'il n'est plus visible
                this.revealElementsInView = this.revealElementsInView.filter(el => el !== entry.target);
            }
            //console.log(this.revealElementsInView);
        });


    },
    handleGlobalOpacity() {
        // if (this.locomotiveScroll) {
        //     this.locomotiveScroll.on('scroll', (args) => {
        //         const elements = document.querySelectorAll('.reveal-opacity');
        //         elements.forEach(el => {
        //             const rect = el.getBoundingClientRect();
        //             const viewportHeight = window.innerHeight;
        //             const elementMidpoint = rect.top + (rect.height / 2);
        //             const viewportMidpoint = viewportHeight / 2;
        //
        //             let opacity = Math.min(1, Math.max(0, 1 - Math.abs(viewportMidpoint - elementMidpoint) / viewportMidpoint));
        //             el.style.opacity = opacity;
        //             el.style.transition = 'opacity 0.6s ease';
        //         });
        //     });
        // }
    },

    handleRevealTxt(entries) {
        entries.forEach(entry => {


            // const viewportHeight = window.innerHeight;
            // const elementRect = entry.boundingClientRect;
            // const elementTop = elementRect.top;
            // const elementHeight = elementRect.height;
            //
            // // Calculer le ratio d'intersection en fonction de la position de scroll
            // let scrollPosition = scroll.Y || 0;
            // let scrollRatio = Math.min(Math.max((viewportHeight - elementTop + scrollPosition) / viewportHeight, 0), 1);
            //
            // console.log(scroll.Y + " -- " + scrollRatio);
            //
            // // Appliquer l'opacité progressivement de 0 à 1
            // entry.target.style.transition = 'opacity 0.6s ease';
            // entry.target.style.opacity = scrollRatio;

            //if (entry.intersectionRatio > this.observRatio) {
            //     console.log(entry.target + " - " + entry.intersectionRatio);
            //     const viewportHeight = window.innerHeight;
            //     const elementRect = entry.boundingClientRect;
            //     const elementTop = elementRect.top;
            //     const elementHeight = elementRect.height;
            //     let opacity = Math.min(Math.max((viewportHeight - elementTop) / viewportHeight, 0), 1);
            //
            //     //console.log(scroll.locomotiveScroll.scroll.instance);
            //     // Ajuster l'opacité en fonction de la direction du scroll
            //     if (scroll.locomotiveScroll && scroll.locomotiveScroll.scroll.instance.direction === 'down') {
            //         console.log("down");
            //         entry.target.style.opacity = opacity;
            //     } else if (scroll.locomotiveScroll && scroll.locomotiveScroll.scroll.instance.direction === 'up') {
            //         // && elementRect.bottom > viewportHeight * 0.7
            //         console.log("up");
            //         entry.target.style.opacity = opacity;
            //     } else {
            //         //entry.target.style.opacity = 0;
            //     }
            //
            //     entry.target.style.transition = 'opacity 0.6s ease';
            //}

            // }else{
            //     entry.target.style.opacity = 0;
            // }
        });
    },


    locomotive() {

        let _this = this;

        if (window.innerWidth < 768) {
            document.querySelectorAll('[data-scroll-speed]').forEach(el => {
                el.removeAttribute('data-scroll-speed');
            });
        }

        setTimeout(() => {

            const isMobile = window.innerWidth < 768;

            this.locomotiveScroll = new LocomotiveScroll({
                lenisOptions: {
                    lerp: isMobile ? 0 : 0.1,
                    duration: 1.2,
                    orientation: 'vertical',
                    gestureOrientation: 'vertical',
                    smoothWheel: true,
                    smoothTouch: false,
                    wheelMultiplier: 1,
                    touchMultiplier: 2,
                    normalizeWheel: true,
                    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // https://www.desmos.com/calculator/brs54l4xou
                },
            });

            // const elements = document.querySelectorAll('.reveal-opacity');
            // elements.forEach(el => {
            //     this.locomotiveScroll.addScrollElements({
            //         el,
            //         offset: '0%',
            //         callback: (progress) => {
            //             const viewportHeight = window.innerHeight;
            //             const elementTop = el.getBoundingClientRect().top;
            //             const elementMidpoint = elementTop + el.getBoundingClientRect().height / 2;
            //             const viewportMidpoint = viewportHeight / 2;
            //
            //             let opacity = Math.min(1, Math.max(0, 1 - Math.abs(viewportMidpoint - elementMidpoint) / viewportMidpoint));
            //             el.style.opacity = opacity;
            //             el.style.transition = 'opacity 0.6s ease';
            //         }
            //     });
            // });


            //console.log(this.locomotiveScroll);

            window.addEventListener('scroll', function () {
                scroll.Y = window.scrollY;

                if (scroll.Y > 300 && !isMobile) {
                    $("header").addClass("_move");
                } else {
                    $("header").removeClass("_move");
                }

            });

            // this.revealElementsInView.forEach(el => {
            //     const elementRect = el.getBoundingClientRect();
            //     const viewportHeight = window.innerHeight;
            //     const elementCenter = elementRect.top + (elementRect.height / 2);
            //
            //     // Calculer l'opacité en fonction de la position de l'élément
            //     let opacity;
            //     if (elementCenter >= viewportHeight * 0.3 && elementCenter <= viewportHeight * 0.95) {
            //         opacity = 1;
            //     } else if (elementCenter < viewportHeight * 0.3) {
            //         opacity = Math.max(elementCenter / (viewportHeight * 0.3), 0);
            //     } else if (elementCenter > viewportHeight * 0.95) {
            //         opacity = Math.max(1 - ((elementCenter - viewportHeight * 0.95) / (viewportHeight * 0.1)), 0);
            //     } else {
            //         opacity = 0;
            //     }
            //
            //     // Appliquer l'opacité
            //     el.style.opacity = opacity;
            // });


            // this.locomotiveScroll = new LocomotiveScroll({
            //     el: document.querySelector('.barba-container'),
            //     smooth: true,
            //     gestureDirection: "vertical",
            //     lerp: 0.07, // Réduire légèrement le lerp pour réduire les tremblements
            //     multiplier: 0.8, // Augmenter le multiplier pour un scroll plus fluide
            //     touchMultiplier: 1.1, // Réduire la sensibilité du scroll sur mobile
            //     smoothMobile: true, // Activer le smooth sur mobile pour éviter les tremblements
            //     getDirection: true,
            //     smartphone: {
            //         smooth: true
            //     },
            //     tablet: {
            //         smooth: true
            //     }
            // });

            this.locomotiveScroll.scrollTo(0, {duration: 0, disableLerp: true});

            // this.locomotiveScroll.on("scroll", (args) => {
            //
            // });

            // this.locomotiveScroll.on("scroll", (e) => {
            //     // scroll.Y = e.scroll.y;
            //     // scroll.direction = e.direction;
            //
            //     console.log(e);
            //
            //
            //     // this.revealElementsInView.forEach(el => {
            //     //     const elementRect = el.getBoundingClientRect();
            //     //     const viewportHeight = window.innerHeight;
            //     //     const elementCenter = elementRect.top + (elementRect.height / 2);
            //     //
            //     //     // Calculer l'opacité en fonction de la position de l'élément
            //     //     let opacity;
            //     //     if (elementCenter >= viewportHeight * 0.3 && elementCenter <= viewportHeight * 0.95) {
            //     //         opacity = 1;
            //     //     } else if (elementCenter < viewportHeight * 0.3) {
            //     //         opacity = Math.max(elementCenter / (viewportHeight * 0.3), 0);
            //     //     } else if (elementCenter > viewportHeight * 0.95) {
            //     //         opacity = Math.max(1 - ((elementCenter - viewportHeight * 0.95) / (viewportHeight * 0.1)), 0);
            //     //     } else {
            //     //         opacity = 0;
            //     //     }
            //     //
            //     //     // Appliquer l'opacité
            //     //     el.style.opacity = opacity;
            //     // });
            //
            //
            //     // document.querySelectorAll('.reveal-txt').forEach(el => {
            //     //     const elementRect = el.getBoundingClientRect();
            //     //     const viewportHeight = window.innerHeight;
            //     //     const elementTop = elementRect.top;
            //     //     const elementBottom = elementRect.bottom;
            //     //
            //     //     // Calculer l'opacité en fonction de la position de l'élément
            //     //     let visibilityRatio = (viewportHeight - elementTop) / viewportHeight;
            //     //     let opacity;
            //     //
            //     //     if (visibilityRatio >= 0.3 && visibilityRatio <= 0.9) {
            //     //         opacity = 1;
            //     //     } else if (visibilityRatio < 0.3) {
            //     //         opacity = visibilityRatio / 0.3;
            //     //     } else if (visibilityRatio > 0.9) {
            //     //         opacity = Math.max(1 - ((visibilityRatio - 0.9) / 0.1), 0);
            //     //     } else {
            //     //         opacity = 0;
            //     //     }
            //     //
            //     //     // Appliquer l'opacité
            //     //     el.style.opacity = opacity;
            //     // });
            //
            //
            //     //
            //     // //console.log(scroll.Y);
            //     // const header = document.querySelector("header");
            //     // if (e.scroll.y > 100) {
            //     //     header.classList.add("_mov_header");
            //     // } else {
            //     //     header.classList.remove("_mov_header", "_force_header");
            //     // }
            //     //
            //     // if (e.direction === "down") {
            //     //     header.classList.remove("_force_header");
            //     // }
            // });
            //
            // // Désactiver l'update automatique sur l'événement 'call' pour éviter les tremblements
            // this.locomotiveScroll.on("call", (func) => {
            //     if (func === 'sticky') {
            //         // Supprimer la mise à jour fréquente qui causait les tremblements
            //         console.log("Sticky element in view");
            //     }
            // });

            // setTimeout(() => {
            //     _this.initSectionObserver();
            // }, 500);


        }, 300);


    },

    // interpolateColor(color1, color2, factor) {
    //     const hexToRgb = hex => {
    //         const bigint = parseInt(hex.replace("#", ""), 16);
    //         const r = (bigint >> 16) & 255;
    //         const g = (bigint >> 8) & 255;
    //         const b = bigint & 255;
    //         return [r, g, b];
    //     };
    //
    //     const rgb1 = hexToRgb(color1);
    //     const rgb2 = hexToRgb(color2);
    //     const result = rgb1.map((value, index) => Math.round(value + factor * (rgb2[index] - value)));
    //     return `rgb(${result[0]}, ${result[1]}, ${result[2]})`;
    // },

    destroy() {
        if (this.locomotiveScroll) {
            this.locomotiveScroll.destroy();
            this.locomotiveScroll = null;
        }
    },
    stop() {
        if (this.locomotiveScroll) {
            this.locomotiveScroll.stop();
            //this.locomotiveScroll = null;
        }
    },
    update() {
        if (this.locomotiveScroll) {
            requestAnimationFrame(() => this.locomotiveScroll.resize());
        }
    }
};

export default scroll;
